export enum EditFieldMetadataTypeEnum {
    CountryList = 'CountryList',
    CurrencyCode = 'CurrencyCode',
    UnitOfMeasure = 'UnitOfMeasure',
    PlaceOfExport = 'PlaceOfExport',
    DestinationProvince = 'DestinationProvince',
    TariffTreatment = 'TariffTreatment',
    TariffCode = 'TariffCode',
    //OrderInCouncil = 'OrderInCouncil',
    TimeLimitType = 'TimeLimitType',
    ExciseTaxCode = 'ExciseTaxCode',
    GSTCode = 'GSTCode',
    USPortOfExit = 'USPortOfExit',
    ModeOfTransport = 'ModeOfTransport',
    PortOfUnladingRegion = 'PortOfUnladingRegion',
    PortOfUnlading = 'PortOfUnlading'
}
